export default {
  All: 'All',
  Rented: 'Rented',
  Idle: 'Idle',
  meau: {
    back: 'Quay lại trang web chính thức',
    nav1: 'Cuộc thi Orion',
    nav2: 'Chế độ thuê dài hạn',
    nav3: 'Chế độ thuê ngắn hạn',
    nav4: 'Danh sách thiết bị',
  },
  footer: {
    link: 'Tìm hiểu thêm',
    community: 'Theo dõi cộng đồng',
    tip: 'Lưu ý: Cộng đồng bao gồm Twitter, Telegram, Reddit, Medium, Discord, TikTok, YouTube',
  },

  home: {
    title1: 'Orion',
    title2: 'Cuộc thi Sức mạnh Tính toán GPU',
    text: 'Cuộc thi Sức mạnh Tính toán GPU Orion của Giao thức DeepLink là một cuộc thi khuyến khích quan trọng nhằm khuyến khích các thợ đào tham gia tích cực vào việc thử nghiệm mạng DeepLink. Cuộc thi này là một bước chuẩn bị thiết yếu trước khi ra mắt chính thức nền tảng giao thức trò chơi đám mây lớn nhất thế giới DeepLink, cung cấp nền tảng kỹ thuật vững chắc và hỗ trợ sức mạnh tính toán hiệu quả cho người dùng toàn cầu trong tương lai',
    text1: 'Tổng số GPU hiện tại trong mạng DeepLink là {gpu_num}',
    text2: 'Cuộc thi đã bắt đầu, phần thưởng sẽ được khởi động khi số lượng GPU đạt tiêu chuẩn!',
    btn_text1: 'Cuộc thi chế độ thuê dài hạn - Đã kết thúc',
    btn_title1: 'GPUs {long_term} hiện tại',
    btn_text2: 'Cuộc thi chế độ thuê ngắn hạn - Giai đoạn 4',

    btn_title2: 'Hiện tại {short_term} GPUs',
    cont2_text1:
      'Tổng phần thưởng token cho cuộc thi sức mạnh tính toán Orion là 3 tỷ, với 2 tỷ DLC cho chế độ thuê dài hạn và 1 tỷ DLC cho chế độ thuê ngắn hạn, kéo dài 180 ngày. Cuộc thi được chia thành ba đợt, mỗi đợt kéo dài 60 ngày với khoảng cách từ 5-10 ngày.',
    cont2_btn1: 'Chế độ thuê dài hạn',
    cont2_btn2: 'Chế độ thuê ngắn hạn',
    cont3: {
      text1: 'Tổng giá trị năng \n lực tính toán',
      text2: 'Tổng số GPU',
      text3: 'Tổng số bể \n tính toán',
      text4: 'Tỷ lệ \n thuê GPU',
      text5: 'Tổng phần thưởng DLC',
      text6: 'Số lượng \n DLC đã đốt',
      text7: 'Số lượng DLC đã cam \n kết cho máy khai thác',
      text8: 'Số GPU đang trực tuyến',
      text9: 'Tỷ lệ thuê GPU trực tuyến',
    },
    cont4: {
      li1: 'Xếp hạng cuộc thi',
      li2: 'Tên thợ mỏ',
      li3: 'Năng lực tính toán',
      li4: 'Số lượng GPU',
      li5: 'Tỷ lệ thuê',
      li6: 'Số lượng thuê',
      li7: 'Số phần thưởng đã mở khóa',
      li8: 'Tổng số phần thưởng',
      li9: 'Số GPU đang trực tuyến',
      li10: 'Tỷ lệ thuê GPU trực tuyến',
    },
  },
  long_rule: {
    title: 'Quy tắc cuộc thi chế độ thuê dài hạn',
    text1: 'Tổng số GPU hiện tại trong chế độ thuê dài hạn của mạng DeepLink là {long_num}',
    text2:
      'Trong suốt cuộc thi, các thợ đào có thể nhận được tổng cộng 2 tỷ DLC phần thưởng, và 100% tiền thuê DLC do người dùng thanh toán sẽ bị đốt cháy',
    competition_phase_two_in_progress: 'Giai đoạn hai của cuộc thi đang diễn ra',
    cont2: {
      title: '1. Quy tắc tham gia',
      text1_1: 'Thợ đào tham gia cuộc thi sức mạnh tính toán Orion cần sở hữu một NFT nút ( tìm hiểu thêm về nút: ',
      text1_2:
        '). Trong thời gian diễn ra cuộc thi, một máy GPU đơn lẻ có thể sở hữu nhiều nút, và số lượng token phần thưởng được nhân với số lượng nút. Giới hạn số lượng NFT nút trên mỗi máy là 20.',
      text2_1:
        'Yêu cầu tối thiểu cho các thông số máy chủ GPU: \n Máy chủ tính toán phải đáp ứng các yêu cầu tối thiểu \n để vượt qua kiểm duyệt của người xác minh và được đưa lên mạng, nếu không sẽ không thể tạo ra doanh thu.',
      text3_1: 'GPU',
      text3_2: 'Phải là thẻ đồ họa dòng Nvidia; các mẫu từ dòng 20, 30, 40 hoặc 50',
      text4_1: 'Bộ nhớ',
      text4_2: 'Yêu cầu tối thiểu là 16G mỗi thẻ, khuyến nghị 32G',
      text5_1: 'CPU',
      text5_2:
        'Phải đáp ứng các yêu cầu của trò chơi đám mây: Intel/AMD, tần số chính 3.0GHz hoặc tần số turbo trên 3.5GHz; mỗi GPU cần một CPU riêng và phải có thể chạy Black Myth: Wukong mượt mà, ví dụ: Intel thế hệ thứ 10 trở lên, AMD 5600 trở lên',
      text6_1: 'Ổ cứng',
      text6_2: 'Ổ đĩa hệ thống phải trên 100G SSD, ổ đĩa dữ liệu phải trên 3T SSD, hoặc sử dụng hệ thống không ổ đĩa',
      text7_1: 'Vị trí',
      text7_2: 'Nên đặt máy trong trung tâm dữ liệu IDC để tránh bị phạt do mạng và điện không ổn định',
      text8_1: 'Băng thông mạng',
      text8_2: 'Nên có ít nhất 10M băng thông đầu vào cho mỗi máy GPU',
    },
    cont3: {
      title: '2. Quy tắc tính toán năng lực tính toán',
      text: 'Phí thuê cho các thiết bị đầu cuối trong toàn bộ hệ sinh thái được thống nhất dựa trên giá trị tính toán của hệ thống. Thu nhập từ việc thuê DLC là 0,6 USD/C/tháng. Mô hình tính toán như sau: Năng lực tính toán của toàn bộ máy = (25 * số thẻ + bộ nhớ/3,5 + (√(số lõi CUDA) * √(bộ nhớ/10)) * số GPU), khi hệ số khu vực là 1, giá trị năng lực tính toán như sau:',
      li1: 'Loại GPU',
      li2: 'Lõi CUDA',
      li3: 'Bộ nhớ',
      li4: 'Số lượng GPU',
      li5: 'Bộ nhớ (G)',
      li6: 'Năng lực tính toán của toàn bộ máy (C)',
      li7: 'Tiền thuê toàn bộ máy (USD)',
      li8: 'Tỷ lệ thuê mỗi thẻ mỗi tháng (USD)',
    },
    cont4: {
      title: '3. Hệ số khu vực',
      li1: 'Khu vực',
      li2: 'Hệ số',
      li_text1: 'Trung Quốc đại lục',
      li_text2: 'Bắc Mỹ',
      li_text3: 'Nam Mỹ',
      li_text4: 'Châu Âu',
      li_text5: 'Trung Đông',
      li_text6: 'Hàn Quốc',
      li_text7: 'Nhật Bản',
      li_text8: 'Đài Loan, Trung Quốc',
      li_text9: 'Hồng Kông và Ma Cao, Trung Quốc',
      li_text10: 'Malaysia',
      li_text11: 'Indonesia',
      li_text12: 'Singapore',
      li_text13: 'Việt Nam',
      text1:
        'Công thức tính toán năng lực của máy: (25 * số thẻ + bộ nhớ/3.5 + (√(số lõi CUDA) * √(bộ nhớ/10)) * số GPU) * hệ số khu vực * hệ số mô hình lớn',
      text2: 'Mô hình máy:',
      text3: 'Số lượng GPU:',
      text4: 'Dung lượng bộ nhớ:',
      text5: 'Khu vực:',
      text6: 'Vui lòng chọn',
      text7: 'Giá trị năng lực tính toán hiện tại của máy là: {total}',
    },
    cont5: {
      title:
        '4. Cơ chế Thưởng (Dựa trên DLC tương thích EVM trên Chuỗi công khai DBC AI, Địa chỉ trình duyệt: https://test.dbcscan.io/)',
      text1:
        'Tổng phần thưởng token cho các máy GPU ở chế độ thuê dài hạn IDC trong cuộc thi sức mạnh tính toán Orion là 2 tỷ, kéo dài 180 ngày. Cuộc thi được chia thành 3 vòng, với khoảng cách 5-10 ngày giữa mỗi vòng.',
      text2: 'Cuộc thi 1: Cuộc thi sẽ chính thức bắt đầu khi số lượng GPU của mỗi loại đạt {n_gpu1}.',
      text3:
        '60 ngày, 6 triệu token mỗi ngày, 10% nhận ngay lập tức, 90% mở khóa trong vòng 180 ngày, với 0,5% mở khóa hàng ngày.',
      text4: 'Cuộc thi 2: Cuộc thi sẽ chính thức bắt đầu khi số lượng GPU của mỗi loại đạt {n_gpu2}.',
      text5:
        '60 ngày, 8 triệu token mỗi ngày, 10% nhận ngay lập tức, 90% mở khóa trong vòng 180 ngày, với 0,5% mở khóa hàng ngày.',
      text6: 'Cuộc thi 3: Cuộc thi sẽ chính thức bắt đầu khi số lượng GPU của mỗi loại đạt {n_gpu3}.',
      text7:
        '60 ngày, 19,33 triệu token mỗi ngày, 10% nhận ngay lập tức, 90% mở khóa trong vòng 180 ngày, với 0,5% mở khóa hàng ngày.',
      text8: 'Sau khi niêm yết trên sàn giao dịch, token thử nghiệm có thể đổi 1:1 cho token mạng chính.',
      text9: 'DeepLink sử dụng thuật toán thưởng phi tuyến.',
      text10:
        'Tổng số token được thưởng trong hệ thống này được cố định hàng ngày. Phần thưởng mà một máy nhận được liên quan đến sức mạnh tính toán X của máy, thời gian khai thác hiệu quả Y và số lượng token đặt cọc. Càng đặt cọc nhiều token, phần thưởng càng cao; tuy nhiên, không tuân theo mối quan hệ tăng trưởng tuyến tính. Cơ sở phần thưởng cho 0-10.000 token là giống nhau, nhưng đối với số lượng trên 10.000 token, phần thưởng được tính dựa trên một hàm. Nếu máy đang ở trạng thái thuê, sức mạnh tính toán của nó sẽ tăng 30%.',
      text11: 'Công thức tính phần thưởng:',
      text12: 'R: Tổng số lượng token phần thưởng hàng ngày (giá trị cố định)',
      text13: 'Số lượng token đặt cọc cho máy i',
      text14: 'Sức mạnh tính toán của máy i',
      text15: 'Thời gian khai thác hiệu quả của máy i',
      text16: '',
      title1: 'Số lượng đặt cọc:',
      text1_1: '1) Bạn có thể chọn bất kỳ số lượng token nào để đặt cọc hoặc không đặt cọc.',
      text1_2:
        '2) Đối với số lượng đặt cọc từ 0-10.000, số phần thưởng là như nhau; đối với số lượng trên 10.000, phần thưởng tăng theo cách không tuyến tính.',
      text1_3:
        '3) Khi số lượng đặt cọc dưới 10.000, mỗi lần rút phần thưởng sẽ đóng góp trước vào số lượng đặt cọc cho đến khi đạt đủ 10.000.',
      text1_4:
        '4) Phần thưởng cho 100.000 token là 1.23026 lần so với phần thưởng cho 10.000 token, tức là tăng khoảng 23.03%. Đối với 1.000.000 token, phần thưởng là 1.46052 lần, tức là tăng khoảng 46.05%. Đối với 10.000.000 token, phần thưởng là 1.69078 lần, tức là tăng khoảng 69.08%, và đối với 100.000.000 token, phần thưởng là 1.92103 lần, tức là tăng khoảng 92.10%.',
      title2: 'Rút phần thưởng:',
      text2_1:
        'Bạn có thể rút phần thưởng mỗi 24 giờ. Mỗi lần rút, 10% phần thưởng mới sinh ra có thể rút ngay lập tức, trong khi 90% còn lại bị khóa trong 180 ngày. Phần bị khóa được mở khóa 0.5% mỗi lần rút, và sẽ hoàn toàn mở khóa sau 180 ngày.',
      block_title1: 'Lưu Ý Đặc Biệt:',
      block_text1_1: 'Chế độ cho thuê dài hạn yêu cầu thêm máy GPU vào mạng DBC trước. Tài liệu tham khảo:',
      block_text1_2:
        '. Sau đó, các thợ đào cần tự thuê máy trước khi có thể tham gia vào mạng DLC, từ đó có được thu nhập từ cả DBC và DLC. Thu nhập DBC sau khi tham gia mạng DBC = phần thưởng DBC - 30% phí thuê.',
      block_title2: 'Công Thức Tính Thu Nhập Hàng Ngày Từ DBC Của Máy:',
      block_text2:
        'Công suất tính toán của máy / tổng công suất tính toán của mạng * 547.945 * giá DBC * hệ số khu vực * 1,3 (công suất tính toán tăng 30% khi được thuê) - công suất tính toán của máy * hệ số khu vực * 0,01693 * 30% (thu nhập hàng ngày cho mỗi đơn vị công suất tính toán là 0,01693 USD).',
      text3_13:
        'Thu nhập hàng ngày hiện tại là: {usdt1} USD tương đương DBC = Phần thưởng trên chuỗi: {dbc} DBC (tương đương {usdt2} USD với giá DBC hiện tại là {dbc_price} USD) - 30% phí thuê: {usdt3} USD tương đương DBC.',
      title4: 'Công Thức Tính Thu Nhập Hàng Ngày Từ DLC Của Máy: DLC tính theo giá {price} USD.',
      text4_1: 'Mẫu GPU:',
      text4_2: 'Dung lượng bộ nhớ:',
      text4_3: 'Số lượng NFT Node:',
      text4_4: 'Khu vực:',
      text4_5: 'Số lượng DLC đặt cược:',
      text4_6: 'Giai đoạn cuộc thi:',
      text4_6_1: 'Giai đoạn 1: 6 triệu DLC mỗi ngày.',
      text4_6_2: 'Giai đoạn 2: 8 triệu DLC mỗi ngày.',
      text4_6_3: 'Giai đoạn 3: 19,33 triệu DLC mỗi ngày.',
      text4_7: 'Tổng số GPU tham gia:',
      text4_8:
        '(Tổng số GPU được tính toán đồng nhất dựa trên mẫu 4060, 32GB, với trung bình 10 NFT và trung bình đặt cọc 100.000 token)',
      title5: 'Phần thưởng trên chuỗi: {dlc_num} DLC (tương đương {usdt_num} USD với giá DLC hiện tại là {price} USD).',
      req_title1: '5. Cơ Chế Báo Cáo Và Xác Minh (Dựa trên DLC tương thích EVM trên chuỗi công khai DBC AI)',
      req_text1:
        'Người dùng thuê máy DLC có thể báo cáo bất kỳ lúc nào. Cần đặt cược 10.000 DLC để bắt đầu báo cáo. Khi báo cáo, thông tin báo cáo sẽ được đưa vào quy trình xác minh của người xác nhận DBC.',
      req_title2: '6. Cơ Chế Hình Phạt (Dựa trên DLC tương thích EVM trên chuỗi công khai DBC AI)',
      req_text2:
        'Sau khi báo cáo DLC được xác minh, nếu có vấn đề với xác minh, các token DBC đã đặt cược sẽ bị trừ theo quy tắc và tối đa 10.000 DLC token sẽ bị trừ. Các token đã đặt cược này sẽ được thưởng cho người báo cáo.',
      req_title3: '7. Cơ Chế Thanh Toán Và Đốt (Dựa trên DLC tương thích EVM trên chuỗi công khai DBC AI)',
      req_text3:
        'Người dùng thanh toán DLC (giá GPU trong mạng DLC cao hơn 20% so với mạng DBC) để có quyền thuê máy. DLC được người dùng thanh toán sẽ được đốt 100% trong hợp đồng thông minh, có thể tra cứu mỗi lần thanh toán và ghi nhận đốt.',
    },
  },
  short_rule: {
    title: 'Quy Tắc Cuộc Thi Chế Độ Thuê Ngắn Hạn',
    text1: 'Số lượng GPU trong chế độ thuê ngắn hạn trên mạng DeepLink hiện tại là {short_num}.',
    text2:
      'Trong suốt cuộc thi, các thợ đào có thể nhận được tổng cộng 1 tỷ DLC tiền thưởng, và phí thuê DLC do người dùng thanh toán sẽ được đốt cháy hoàn toàn.',
    competition_phase_two_in_progress: 'Giai đoạn bốn của cuộc thi đang diễn ra',
    cont2: {
      title: '1. Quy Tắc Tham Gia',
      text1_1: 'Người tham gia cuộc thi tính toán Orion cần phải sở hữu một Node NFT (Thông tin chi tiết về các nút:',
      text1_2:
        '). Trong thời gian thi đấu, một máy GPU có thể giữ nhiều nút, số lượng token thưởng tỷ lệ thuận với số lượng nút. Số lượng tối đa Node NFT mà một máy có thể giữ là 20.',
      text2_1:
        'Yêu cầu tối thiểu về tham số máy chủ GPU: \n Các tham số của máy chủ tính toán phải đáp ứng yêu cầu tối thiểu.',
      text3_1: 'GPU',
      text3_2: 'Phải là card đồ họa dòng Nvidia; các mẫu bao gồm dòng 20, 30, 40 và 50.',
      text4_1: 'Bộ Nhớ',
      text4_2: 'Yêu cầu tối thiểu về bộ nhớ là 16G cho mỗi card, 32G được khuyến nghị.',
      text5_1: 'CPU',
      text5_2:
        'Phải đáp ứng các yêu cầu chơi game đám mây: Intel/AMD với tần số cơ bản 3.0GHz hoặc tần số tăng cường ít nhất 3.5GHz; mỗi GPU yêu cầu một CPU riêng biệt, có thể chạy mượt mà Black Myth: Wukong. Ví dụ: Intel thế hệ 10 trở lên, AMD 5600 trở lên.',
      text6_1: 'Ổ Cứng',
      text6_2: 'Đĩa hệ thống 2T SSD trở lên, đĩa dữ liệu 1T trở lên',
      text7_1: 'Vị Trí',
      text7_2: 'Máy có thể đặt tại nhà.',
      text8_1: 'Băng Thông Mạng:',
      text8_2: 'Mỗi máy GPU nên có ít nhất 10M băng thông tải lên.',
    },
    cont3: {
      title: '2. Quy Tắc Tính Toán Sức Mạnh Tính Toán',
      text: 'Trong toàn bộ hệ sinh thái, phí thuê cho người dùng được thống nhất dựa trên hệ thống định giá giá trị tính toán. Thu nhập từ việc thuê DLC là 0,508 USD/C/tháng. Mô hình tính toán như sau: Giá trị sức mạnh tính toán của toàn bộ máy = (25 * số lượng thẻ + bộ nhớ/3,5 + (√(số lượng lõi CUDA) * √(bộ nhớ video/10)) * số lượng card đồ họa).',
    },
    cont4: {
      title: '3. Hệ số khu vực',
      li1: 'Khu vực',
      li2: 'Hệ số',
      li_text1: 'Trung Quốc đại lục',
      li_text2: 'Bắc Mỹ',
      li_text3: 'Nam Mỹ',
      li_text4: 'Châu Âu',
      li_text5: 'Trung Đông',
      li_text6: 'Hàn Quốc',
      li_text7: 'Nhật Bản',
      li_text8: 'Đài Loan, Trung Quốc',
      li_text9: 'Hồng Kông và Ma Cao, Trung Quốc',
      li_text10: 'Malaysia',
      li_text11: 'Indonesia',
      li_text12: 'Singapore',
      li_text13: 'Việt Nam',
      text1:
        'Công thức tính toán năng lực của máy: (25 * số thẻ + bộ nhớ/3.5 + (√(số lõi CUDA) * √(bộ nhớ/10)) * số GPU) * hệ số mô hình lớn',
      text2: 'Mô hình máy:',
      text3: 'Số lượng GPU:',
      text4: 'Dung lượng bộ nhớ:',
      text5: 'Khu vực:',
      text6: 'Vui lòng chọn',
      text7: 'Giá trị năng lực tính toán hiện tại của máy là: {total}',
    },
    cont5: {
      title:
        '4. Cơ Chế Thưởng (Dựa trên DLC tương thích EVM của Chuỗi Công Cộng DBC AI, địa chỉ trình duyệt: https://test.dbcscan.io/)',
      text1:
        'Tổng phần thưởng token cho các máy GPU cá nhân cho thuê ngắn hạn trong cuộc thi tính toán Orion là 1 tỷ, kéo dài trong 180 ngày. Cuộc thi được chia thành 3 giai đoạn, với khoảng cách 5-10 ngày giữa mỗi giai đoạn.',
      text2: 'Giai đoạn 1 của Cuộc Thi: Cuộc thi chỉ chính thức bắt đầu khi số lượng mỗi loại GPU đạt {n_gpu1}.',
      text3:
        '60 ngày, 3 triệu token mỗi ngày, 10% được mở khóa ngay lập tức, 90% được mở khóa trong vòng 180 ngày, với 0,5% được mở khóa mỗi ngày.',
      text4: 'Giai đoạn 2 của Cuộc Thi: Cuộc thi chỉ chính thức bắt đầu khi số lượng mỗi loại GPU đạt {n_gpu2}.',
      text5:
        '60 ngày, 4 triệu token mỗi ngày, 10% được mở khóa ngay lập tức, 90% được mở khóa trong vòng 180 ngày, với 0,5% được mở khóa mỗi ngày.',
      text6: 'Giai đoạn 3 của Cuộc Thi: Cuộc thi chỉ chính thức bắt đầu khi số lượng mỗi loại GPU đạt {n_gpu3}.',
      text7:
        '60 ngày, 9,665 triệu token mỗi ngày, 10% được mở khóa ngay lập tức, 90% được mở khóa trong vòng 180 ngày, với 0,5% được mở khóa mỗi ngày.',
      text8: 'Sau khi niêm yết trên sàn giao dịch, token thử nghiệm có thể đổi 1:1 cho token mạng chính.',
      text9: 'DeepLink sử dụng thuật toán thưởng phi tuyến.',
      text10:
        'Tổng số token được thưởng trong hệ thống này được cố định hàng ngày. Phần thưởng mà một máy nhận được liên quan đến sức mạnh tính toán X của máy, thời gian khai thác hiệu quả Y và số lượng token đặt cọc. Càng đặt cọc nhiều token, phần thưởng càng cao; tuy nhiên, không tuân theo mối quan hệ tăng trưởng tuyến tính. Cơ sở phần thưởng cho 0-10.000 token là giống nhau, nhưng đối với số lượng trên 10.000 token, phần thưởng được tính dựa trên một hàm. Nếu máy đang ở trạng thái thuê, sức mạnh tính toán của nó sẽ tăng 30%.',
      text11: 'Công thức tính phần thưởng:',
      text12: 'R: Tổng số lượng token phần thưởng hàng ngày (giá trị cố định)',
      text13: 'Số lượng token đặt cọc cho máy i',
      text14: 'Sức mạnh tính toán của máy i',
      text15: 'Thời gian khai thác hiệu quả của máy i',
      text16: '',
      title1: 'Số lượng đặt cọc:',
      text1_1: '1) Bạn có thể chọn bất kỳ số lượng token nào để đặt cọc hoặc không đặt cọc.',
      text1_2:
        '2) Đối với số lượng đặt cọc từ 0-10.000, số phần thưởng là như nhau; đối với số lượng trên 10.000, phần thưởng tăng theo cách không tuyến tính.',
      text1_3:
        '3) Khi số lượng đặt cọc dưới 10.000, mỗi lần rút phần thưởng sẽ đóng góp trước vào số lượng đặt cọc cho đến khi đạt đủ 10.000.',
      text1_4:
        '4) Phần thưởng cho 100.000 token là 1.23026 lần so với phần thưởng cho 10.000 token, tức là tăng khoảng 23.03%. Đối với 1.000.000 token, phần thưởng là 1.46052 lần, tức là tăng khoảng 46.05%. Đối với 10.000.000 token, phần thưởng là 1.69078 lần, tức là tăng khoảng 69.08%, và đối với 100.000.000 token, phần thưởng là 1.92103 lần, tức là tăng khoảng 92.10%.',
      title2: 'Rút phần thưởng:',
      text2_1_line1:
        'Phần thưởng có thể rút bất kỳ lúc nào. Nếu ban đầu không đặt cọc DLC hoặc đặt cọc dưới 10.000 DLC, phần thưởng sẽ được tích lũy thành DLC cho đến khi đạt 10.000.',
      text2_1_line2: '1) Tiền thuê sẽ được tích lũy thành tiền cọc cho đến khi đạt 10.000 DLC.',
      text2_1_line3:
        '2) Thời gian thuê tối thiểu là 2 giờ, không giới hạn thời gian tối đa. Nếu thời gian còn lại dưới 1 giờ, máy sẽ không thể cho thuê và không nhận được phần thưởng online. Thợ đào có thể tăng thời gian bất kỳ lúc nào, nhưng mỗi lần tăng tối thiểu phải là 2 giờ.',

      title4: 'Công Thức Tính Toán Doanh Thu DLC Hàng Ngày: DLC được tính theo giá 0,003 USD.',
      text4_8:
        '(Tổng GPU được tính đồng nhất dựa trên 4060 32G, với trung bình 10 NFT và mức đặt cọc trung bình là 10,000 token)',
      title5:
        'Thu Nhập Phần Thưởng Trên Chuỗi: {dlc_num} DLC (tương đương {usdt_num} USD với giá DLC hiện tại là {price} USD).',

      req_title1: '5. Cơ Chế Phát Hiện Trực Tuyến',
      req_text1_1:
        'Máy sẽ chịu sự phát hiện của cơ chế của chuỗi công khai DBC AI, báo cáo thông tin cho cụm phát hiện phân tán DBC để xác định xem máy có trực tuyến hay không. Nếu không trực tuyến, phần thưởng trực tuyến sẽ bị khấu trừ. Nếu xảy ra gián đoạn trong quá trình sử dụng của người dùng, DLC sẽ bị khấu trừ từ người dùng. Giới hạn hình phạt:',
      req_text1_2:
        '1) Nếu không có đồng tiền nào được đặt cược, chỉ thu nhập từ DLC hiện tại sẽ bị phạt, tối đa là 2 giờ tiền thuê.',
      req_text1_3: '2) Nếu DLC được đặt cược, sẽ bị phạt 1.000 DLC.',
      req_text1_4:
        'Máy có cơ chế phát hiện thường trực từ blockchain DBC AI, báo cáo thông tin cho cụm phát hiện phân tán DBC để xác định xem máy có đang trực tuyến hay không. Nếu không trực tuyến, phần thưởng trực tuyến sẽ bị khấu trừ. Nếu có gián đoạn trong quá trình sử dụng, DLC sẽ bị khấu trừ từ người dùng. Hiện tại, mỗi lần gián đoạn sẽ phạt 1000 DLC, sau này sẽ thay đổi linh hoạt theo giá DLC',
      req_title2: '6. Quy Tắc Báo Cáo Máy',
      req_text2:
        'Nếu bất kỳ người dùng nào nghi ngờ cấu hình của máy có thể là giả mạo, họ có thể khởi xướng báo cáo. Nếu thành công, tất cả số tiền đặt cược sẽ bị khấu trừ từ máy và các phần thưởng sẽ bị dừng.',
      req_title3: 'Đặt cược 10.000 DLC và gửi thông tin báo cáo lên chuỗi',
      req_text3:
        'Những người xác minh được ủy quyền bởi DeepLink có thể tham gia xác minh, với 5 người xác minh tham gia mỗi lần xác minh, theo nguyên tắc đa số.',

      text4_6_1: 'Giai đoạn 1: 3 triệu DLC mỗi ngày.',
      text4_6_2: 'Giai đoạn 2: 4 triệu DLC mỗi ngày.',
      text4_6_3: 'Giai đoạn 3: 9,665 triệu DLC mỗi ngày.',
      text4_6_4: 'Giai đoạn 4: 9,665 triệu DLC mỗi ngày.',
      text4_6_5: 'Giai đoạn 5: 9,665 triệu DLC mỗi ngày.',
    },
  },
  country: {
    country1: 'Trung Quốc',
    country2: 'Bắc Mỹ',
    country3: 'Nam Mỹ',
    country4: 'Châu Âu',
    country5: 'Trung Đông',
    country6: 'Hàn Quốc',
    country7: 'Nhật Bản',
    country8: 'Đài Loan, Trung Quốc',
    country9: 'Hồng Kông và Ma Cao, Trung Quốc',
    country10: 'Malaysia',
    country11: 'Indonesia',
    country12: 'Singapore',
    country13: 'Việt Nam',
  },
  device: {
    title: 'Danh Sách Thiết Bị Toàn Mạng',
    title1: 'Xem số lượng máy, trạng thái máy và thông tin chi tiết cho các mẫu GPU khác nhau.',
    table: {
      text1: 'Trạng Thái Sử Dụng Máy:',
      text2: 'Số Lượng GPU:',
      text3: 'Tổng Số Máy:',
      text4: 'Số Lượng Máy Nhàn Rỗi:',
    },
  },
  machine_id: 'ID máy',
  machine_is_rented: 'Có được thuê không',
  machine_rented: 'Đã được thuê',
  machine_idle: 'Rảnh rỗi',
  machine_is_online: 'Có trực tuyến không',
  machine_yes: 'Có',
  machine_no: 'Không',
  machine_no_data: 'Không có dữ liệu',

  deviceUniqueId: 'ID Máy',
  minerLocation: 'Địa chỉ thợ mỏ',
  gpuCount: 'Số lượng GPU',
  computeCapacity: 'Tổng sức mạnh tính toán',
  isActive: 'Trạng thái trực tuyến',
  isPledged: 'Trạng thái đặt cược',
  pledgeTotal: 'Tổng số tiền đặt cược',
  pledgeExpiration: 'Thời gian kết thúc đặt cược',

  yesOption: 'Có',
  noOption: 'Không',
  gpuType: 'Loại GPU',
};
